// web-staking-estimator-frontend/src/components/common/Banner.js
import React from "react";

/**
 * Banner component for displaying success or error messages
 * @param {string} message - The message to display
 * @param {string} kind - "success" or "error" (or "ok"/"err" for backward compatibility)
 */
export function Banner({ message, kind = "success" }) {
  if (!message) return null;
  
  // Normalize kind values
  const normalizedKind = kind === "err" || kind === "error" ? "error" : "success";
  const className = normalizedKind === "error" ? "banner banner-err" : "banner banner-ok";
  
  return <div className={className}>{message}</div>;
}
